import { render, staticRenderFns } from "./ModalModificarAtencionPrestador.vue?vue&type=template&id=b5b53e22&scoped=true&"
import script from "./ModalModificarAtencionPrestador.vue?vue&type=script&lang=js&"
export * from "./ModalModificarAtencionPrestador.vue?vue&type=script&lang=js&"
import style0 from "./ModalModificarAtencionPrestador.vue?vue&type=style&index=0&id=b5b53e22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b53e22",
  null
  
)

export default component.exports